<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-package" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Drugs Manager</h4>
              <small style="opacity: 0.8;">Add and manage drugs in your formulary</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Tab bar -->
          <div class="card shadow-sm tab-card mb-4">
            <div class="card-body py-3 px-4">
              <div class="d-flex flex-wrap" style="gap: 8px;">
                <button class="btn btn-sm tab-btn"
                  :class="showDrug ? 'btn-primary active-tab' : 'btn-outline-secondary'"
                  @click="showDrug = true; showCategory = false; showSubCategory = false">
                  <i class="fe fe-plus mr-1"></i> Add Drug
                </button>
                <button class="btn btn-sm tab-btn"
                  :class="showCategory ? 'btn-primary active-tab' : 'btn-outline-secondary'"
                  @click="showDrug = false; showCategory = true; showSubCategory = false">
                  <i class="fe fe-tag mr-1"></i> Drug Category
                </button>
                <button class="btn btn-sm tab-btn"
                  :class="showSubCategory ? 'btn-primary active-tab' : 'btn-outline-secondary'"
                  @click="showDrug = false; showCategory = false; showSubCategory = true">
                  <i class="fe fe-layers mr-1"></i> Sub Category
                </button>
              </div>
            </div>
          </div>

          <div v-show="showDrug"><AddDrug /></div>
          <div v-show="showCategory"><AddDrugCategory /></div>
          <div v-show="showSubCategory"><AddSubCategory /></div>

        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  import AddDrug from '@/views/drugs/AddDrug.vue'
  import AddDrugCategory from '@/views/drugs/AddDrugCategory.vue'
  import AddSubCategory from '@/views/drugs/AddSubCategory.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading, AddDrug, AddDrugCategory, AddSubCategory
  },
  data(){
    return{
      user:null,
      drugs:"",
      edit:false,
      showDrug:true,
      showCategory:false,
      showSubCategory:false,
      isLoading: false,
      fullPage: true,

    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/drugs`)
                .then(response => {
                    this.drugs = response.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{
    //
  },
  created(){
  //
  }

}
</script>
<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}

.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tab-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
}

.tab-btn {
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.82rem;
  padding: 6px 14px;
}

.active-tab {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-color: transparent;
}
</style>
